import { mountConsentBanner, readConsent } from './consent';
import { resolveGoogleAnalyticsMeasurementId } from './googleAnalytics';
import {
  initBaseTracking,
  trackAnonymousPageView,
  trackEvent,
  trackPageView,
} from './events';

const analyticsEnabled = Boolean(
  import.meta.env.VITE_POSTHOG_KEY ||
  resolveGoogleAnalyticsMeasurementId() ||
  import.meta.env.VITE_META_PIXEL_ID,
);

function getPageName() {
  const page = document.body?.getAttribute('data-page-name');
  if (page) return page;
  return document.title || 'Unknown page';
}

function bindTrackedClicks() {
  document.addEventListener('click', (event) => {
    const target =
      event.target instanceof HTMLElement
        ? event.target.closest('[data-analytics-event]')
        : null;
    const eventName = target?.getAttribute('data-analytics-event');
    if (!eventName) return;
    void trackEvent(eventName, {
      app_surface: document.body?.getAttribute('data-app-surface') || 'site',
      cta_label: target.textContent?.trim() || '',
      cta_href: target.getAttribute('href') || '',
    });
  });
}

function start() {
  document.body?.setAttribute(
    'data-app-surface',
    document.body?.getAttribute('data-app-surface') || 'site',
  );
  if (!analyticsEnabled) return;
  bindTrackedClicks();
  void initBaseTracking();
  if (readConsent() === 'unset') mountConsentBanner();
  window.addEventListener(
    'gc-consent-changed',
    (event) => {
      const value = (event as CustomEvent<{ value: string }>).detail?.value;
      if (value === 'accepted') {
        void trackPageView(getPageName(), {
          app_surface: document.body?.getAttribute('data-app-surface') || 'site',
        });
      }
    },
    { once: true },
  );
  void trackAnonymousPageView(getPageName(), {
    app_surface: document.body?.getAttribute('data-app-surface') || 'site',
  });
  void trackPageView(getPageName(), {
    app_surface: document.body?.getAttribute('data-app-surface') || 'site',
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  start();
}
